<template>
  <div class="alert alert-warning">
    <h5 class="alert-heading">使用須知</h5>
    <hr />
    <ol class="mt-2">
      <li>
        將在「尚未編排的選科組合」的選科組合拖到「已編排的選科組合次序
        」方格內，並按優次排序。
      </li>
      <li>必須排好<strong>所有</strong>選科組合次序</li>
      <li>家長簽署</li>
      <li>確定選科意向</li>
    </ol>
  </div>
</template>
